import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import jQuery from 'jquery';
import ProductInput from './main';
import { createRoot } from 'react-dom/client';
import { GetCommonSettings, GetExtraProducts, GetProductData } from '@themes/common/data';
import AppProvider from '@components/Shared/State/provider';
import SbThemeProvider from '@components/theme/provider';
import { ProductCountdownRenderer } from '../countdown';
export default function LoadProductInput(element) {
    const input = jQuery(element).parent('form').find('[name=id]');
    let id = input.val();
    if (!id) {
        if (input.is('select')) {
            const selectedOption = input.find('option:selected').first();
            if (selectedOption.length > 0) {
                const selectedId = selectedOption.val();
                if (selectedId) {
                    id = selectedId;
                }
            }
        }
        if (!id) {
            return;
        }
    }
    const settings = GetCommonSettings();
    const product = GetProductData(id);
    if (!product) {
        return;
    }
    const extraProducts = GetExtraProducts(id);
    const rootDom = createRoot(element);
    let quantity = parseInt(product.metafields['SB-P']['MinimumQuantity'] || '1', 10);
    if (isNaN(quantity) || quantity < 1) {
        quantity = 1;
    }
    rootDom.render(_jsx(AppProvider, { children: _jsxs(SbThemeProvider, { children: [_jsx(ProductCountdownRenderer, {}), _jsx(ProductInput, { id: product.variant_id, settings: settings, product: product, extraProducts: extraProducts, variantInput: input, quantity: quantity, minimumQuantity: quantity })] }) }));
}
